import angular from 'angular';

angular
  .module('cxSettings')
  .controller('RecognitionOptionsDialogCtrl', [
    '$element',
    '$http',
    'appUrls',
    'flySvc',
    'close',
    'dataCache',
    'magicMailAllowedRecognitionSenders',
    'linkEmailToCrmOther',
    'linkEmailToCrmProspect',
    'linkEmailToCrmOwnCompany',
    recognitionOptionsDialogCtrl,
  ]);

function recognitionOptionsDialogCtrl(
  $element,
  $http,
  appUrls,
  flySvc,
  close,
  dataCache,
  magicMailAllowedRecognitionSenders,
  linkEmailToCrmOther,
  linkEmailToCrmProspect,
  linkEmailToCrmOwnCompany,
) {
  var vm = this;
  vm.magicMailAllowedRecognitionSendersArray = [];
  vm.linkEmailToCrmOther = linkEmailToCrmOther;
  vm.linkEmailToCrmProspect = linkEmailToCrmProspect;
  vm.linkEmailToCrmOwnCompany = linkEmailToCrmOwnCompany;

  if (magicMailAllowedRecognitionSenders) {
    vm.magicMailAllowedRecognitionSendersArray = magicMailAllowedRecognitionSenders.split(';');
  }

  vm.addEmail = () => {
    vm.magicMailAllowedRecognitionSendersArray.push('');
  };

  vm.save = function() {
    close(
      {
        linkEmailToCrmOther: vm.linkEmailToCrmOther,
        linkEmailToCrmProspect: vm.linkEmailToCrmProspect,
        linkEmailToCrmOwnCompany: vm.linkEmailToCrmOwnCompany,
        magicMailAllowedRecognitionSenders:
          vm.magicMailAllowedRecognitionSendersArray.length === 0
            ? ''
            : vm.magicMailAllowedRecognitionSendersArray.join(';'),
      },
      500,
    );
    $element.modal('hide');
  };

  vm.cancel = function() {
    close(null, 500);
    $element.modal('hide');
  };
}
